module.exports = __webpack_public_path__ + "img/license.e88faccf.png";